import queryString from "query-string";

export const jsonToQueryParamData = (data: CalculatorFormDataType) => {
  let processedData = "";
  try {
    processedData = btoa(JSON.stringify(data));
  } catch (e) {}
  const params = {
    data: processedData,
  };
  return queryString.stringify(params);
};

export const getDecodedParamsJsonOrNull = (params: string) => {
  const parsedParams: any = queryString.parse(params);
  if (parsedParams && parsedParams.data) {
    try {
      parsedParams.data = JSON.parse(atob(parsedParams.data || " "));
      if (parsedParams.data && typeof parsedParams.data === "object") {
        // Backward compat: old URLs won't have explicitKeys
        if (!parsedParams.data.explicitKeys && parsedParams.data.products) {
          parsedParams.data.explicitKeys = parsedParams.data.products.map((p: any) => p.key);
        }
        // Backward compat: old URLs use "profile" instead of "deploymentType"
        if (parsedParams.data.highLevelParameters?.profile && !parsedParams.data.highLevelParameters?.deploymentType) {
          parsedParams.data.highLevelParameters.deploymentType = parsedParams.data.highLevelParameters.profile;
          delete parsedParams.data.highLevelParameters.profile;
        }
        return parsedParams.data;
      }
    } catch (e) {
      console.log({ e });
      alert("Error loading shared calculation");
    }
    return null;
  }
};
